// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X1KD","delete":"styles_delete__3oMCJ","update":"styles_update__3nHQ9","add":"styles_add__3FRDS"};